<div class="form">
    <div class="icon">
        <app-svg use="facet-icon"></app-svg>
        <span>{{ 'CATALOG.FACET.LABEL' | translate }}</span>
    </div>
    <form id="catalogForm"
          (submit)="$event.preventDefault();updateUrl();"
          aside
          #form>
        <input type="search"
               hidden
               name="searchTerms"
               id="search-catalog-input-hidden">
        <app-catalog-sort [sortings]="result?.sortings"></app-catalog-sort>
        <app-catalog-facets [facets]="result?.facets"></app-catalog-facets>
        <button class="reset"
                type="button"
                aside
                (click)="resetFacetsInUrl()">{{ 'CATALOG.FACET.RESET_BUTTON' | translate }}</button>
    </form>
    <section> @for(facet of result?.facets; track facet.id) { @for (facetValue of facet?.values; track facetValue?.value) { @if(facetValue?.selected) { <button (click)="deselectFacet(facetValue?.value)">
            <app-svg use="close"></app-svg>
            <span>{{ facetValue?.title ?? facetValue?.value }}</span>
        </button> } } } </section>
</div>
<div class="total-result">{{ result?.totalResults }}<span>&nbsp;{{ 'CATALOG.FACET.TOTALRESULT' | translate }}</span></div>
